import { render } from "./EntityFiles.vue?vue&type=template&id=05d95930&scoped=true"
import script from "./EntityFiles.vue?vue&type=script&lang=js"
export * from "./EntityFiles.vue?vue&type=script&lang=js"

import "./EntityFiles.vue?vue&type=style&index=0&id=05d95930&lang=scss"
import "./EntityFiles.vue?vue&type=style&index=1&id=05d95930&lang=scss&scoped=true"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d95930"]])

export default __exports__